const isNonOrganisationParticipant = (meta) => meta.dispatch(isNonOrganisationParticipantGuardAction(meta));

const isNonOrganisationParticipantGuardAction = (to) => (_dispatch, getState) => {

	const state = getState()

	if (state.auth.userType === 'nonParticipant') {
		return null
	}

	return '/'
}

export { isNonOrganisationParticipant };
